<template>
    <el-dialog
        :title="isManage ? $t('popper_title.manage_your_team_matrials'): $t('popper_title.add_material_from_online')"
        :visible="true"
        @close="onMaterialDialogClose"
        :append-to-body="true"
        :close-on-click-modal="false"
        width="1000px"
        custom-class="codelab-popper material-online-dialog"
    >
        <template v-if="false">
            <el-button class="top-button" v-if="!isManage" @click="isManage = true">
                <svg-icon href="#editor-icon-config" :width="20" :height="20"></svg-icon>
                <span class="button-label">
                    {{$t("button.manage_materials")}}
                </span>
            </el-button>
            <el-button class="top-button" v-else  @click="isManage = false">
                <svg-icon href="#editor-icon-repeal" :width="20" :height="16"></svg-icon>
                <span class="button-label">
                    {{$t("button.back_to_matriallib")}}
                </span>
            </el-button>
        </template>
        <div class="materials-online">
            <template v-if="!isManage">
                <el-tabs class="material-owner-tabs" v-model="materialOwner" @tab-click="switchMaterialOwner">
                    <el-tab-pane :label="$t('label.nuwa_material_lib')" name="nuwa" :disabled="materialOwner === 'nuwa'"></el-tab-pane>
                    <el-tab-pane :label="$t('label.team_material_lib')" :name="teamId" :disabled="materialOwner === teamId"></el-tab-pane>
                </el-tabs>
                <div class="materials-search">
                    <el-select
                    v-if="typedCategories.length > 1 && materialOwner === 'nuwa'"
                    v-model="selectedCategory"
                    @change="onSelectCategory($event, searchMaterialType)"
                    :placeholder="$t('placeholder.material_type_select')"
                    class="material-type-select"
                    popper-class="editor-select-dropdown material-type-select-options"
                    style="width:auto;"
                    >
                        <el-option
                        v-for="category of typedCategories"
                        :label="util$.getI18nLabel$(category.i18n, 'langCode', 'description') || category.short"
                        :key="category.materialCategoryId"
                        :value="category.materialCategoryId"
                        >
                        </el-option>
                    </el-select>
                    <div class="search-right" :class="{'is-customer': materialOwner !== 'nuwa'}">
                        <el-input
                            v-if="showSearchInput"
                            :placeholder="$t('placeholder.serch_online_material')"
                            v-model="searchKeyWord"
                            @change="onSearchKeywordChange"
                            class="key-words-input"
                            ref="searchInput"
                        >
                            <i
                                class="el-input__icon el-icon-close"
                                :class="selectedTags.length === 0 && searchKeyWord? 'el-icon-close': 'el-icon-search'"
                                slot="prefix"
                                @click="closeSearchinput"
                            ></i>
                        </el-input>
                        <div v-if="!showSearchInput" class="selected-tags-slot">
                            <span class="search-icon el-icon-search" @click="onShowSearchinput"></span>
                            <div class="tags-container" @click="toggleTagsList">
                                <span
                                    @click.stop
                                    class="tag-item"
                                    v-for="item in selectedTags"
                                    :key="item.materialTagId"
                                >
                                    {{item.label}}
                                    <i
                                        class="el-icon-close delete-tag"
                                        @click.stop="onDeleteTag(item.materialTagId)"
                                    ></i>
                                </span>
                            </div>
                            <span
                                class="toggle-tag-list el-icon-caret-bottom"
                                @click="toggleTagsList"
                                :class="{active: showTagList}"
                            ></span>
                        </div>
                    </div>
                </div>
                <div class="material-tags-list" v-if="showTagList">
                    <el-scrollbar ref="tagScroll">
                        <div class="tags-container">
                            <span
                                v-for="item in materialTags"
                                :key="item.materialTagId"
                                class="tag-item"
                                :class="{selected: !!selectedTags.find(tag => tag.materialTagId === item.materialTagId)}"
                                @click="onSelectTag(item)"
                            >{{item.label}}</span>
                        </div>
                    </el-scrollbar>
                </div>
            </template>
            <template v-else>
                <div class="manage-tip">
                    {{$t("label.select_materials_to_delete")}}
                </div>
            </template>
            <div class="materials-container">
                <el-scrollbar
                    v-show="filterMaterials.length > 0"
                    ref="matrialsScrollbar"
                    class="materials-online-scrollbar"
                >
                    <template v-if="method === 'add' && !isManage">
                        <el-checkbox-group v-model="selectedIds">
                            <ul 
                            v-infinite-scroll="onMaterialListScroll" 
                            infinite-scroll-immediate="false" 
                            infinite-scroll-disabled="lockScrollUpdate"
                            >
                                <li
                                    v-for="material of filterMaterials"
                                    :key="material.materialId"
                                    :class="{ active: selectedIds.includes(material.materialId) }"
                                    @click="onMaterilSelect(material)"
                                >
                                    <material-item :data="material" :scroll-container="listScrollContainer"></material-item>
                                    <el-checkbox
                                        :label="material.materialId"
                                        :disabled="isInMaterialArea(material.materialId)"
                                        class="select-material-box"
                                    ></el-checkbox>
                                </li>
                            </ul>
                        </el-checkbox-group>
                    </template>
                    <template v-if="method === 'replace' || isManage">
                        <el-radio-group v-model="selectedId">
                            <ul 
                            v-infinite-scroll="onMaterialListScroll" 
                            infinite-scroll-immediate="false" 
                            infinite-scroll-disabled="lockScrollUpdate">
                                <li
                                    v-for="material of filterMaterials"
                                    :key="material.materialId"
                                    :class="{ active: selectedId === material.materialId}"
                                    @click="onMaterilSelect(material)"
                                >
                                    <material-item :data="material" :scroll-container="listScrollContainer"></material-item>
                                    <el-radio
                                        v-if="material.type !== 'content' && !isManage"
                                        :label="material.materialId"
                                        :disabled="isInMaterialArea(material.materialId)"
                                        class="select-material-radio"
                                    ></el-radio>
                                    <el-radio
                                        v-if="isManage"
                                        :label="material.materialId"
                                        class="select-material-radio"
                                    ></el-radio>
                                </li>
                            </ul>
                        </el-radio-group>
                    </template>
                    <div class="data-finale-mask" v-if="showNoMoreData">{{$t("loading.no_more_data")}}</div>
                </el-scrollbar>
                <list-empty v-if="filterMaterials.length === 0"></list-empty>
                <transition name="fade">
                    <div class="scroll-bottom-tip" v-if="scrollUpdating && !showNoMoreData">{{$t("loading.we_are_loading")}}</div>
                </transition>
                
                <transition name="fade">
                    <div class="loading-mask" v-show="showLoadingMask">
                        <ul>
                            <li v-for="item in 20" :key="item" class="bg-item"></li>
                        </ul>
                        <img src="/static/svg/loading.svg" class="loading-icon" width="46" height="46" alt="">
                    </div>
                </transition>
            </div>
        </div>
        <div slot="footer" class="footer-button-group">
            <button
                class="codelab-button popper-footer-button gray"
                @click="onMaterialDialogClose"
            >
                {{ $t("button.cancel") }}
            </button>
            <button
                v-if="!isManage"
                class="codelab-button popper-footer-button blue"
                :class="{ disabled: !canConfirm }"
                @click="confirmMaterials()"
            >
                {{ $t("code-lab/component/connection/set-device-play.vue_10") }}
            </button>
            <button
                v-else
                class="codelab-button popper-footer-button blue"
                :class="{ disabled: !canConfirm }"
                @click="beforeDeleteMaterials()"
            >
                {{ $t("top.delete") }}
            </button>
        </div>
    </el-dialog>
</template>
<script>
/**
 * 在线素材库
 */
import listEmpty from "@/code-lab/component/list-empty.vue";
import materialItem from "./material-item.vue";
import { mapState } from "vuex";
const Cookies = window.Cookies;
export default {
    name: "materials-online",
    props: {
        type: String,
        lockType: {
            type: Boolean,
            default: false
        },
        owner: {
            type: String,
            default: "nuwa"
        },
        method: {
            type: String,
            default: "add"// add/replace/manage
        }
    },
    data() {
        return {
            materialOwner: "nuwa",
            materialStorage: {},
            materialsList: null,
            searchMaterialType: "",
            showSearchInput: false,
            searchKeyWord: "",
            materialTags: [],
            materialCategories: [],
            selectedTags: [],
            selectedCategory: null,
            showTagList: false,
            materialTypes: [
                { key: "role",label: this.$t("material_lib.material_type_role")},
                { key: "image", label: this.$t("custom_photo") },
                { key: "video", label: this.$t("custom_video") },
                { key: "audio", label: this.$t("material_lib.material_type_audio") },
                { key: "motion", label: this.$t("material_lib.material_type_motion") },
                { key: "content", label: this.$t("material_lib.material_type_content") },
                { key: "aiObject", label: this.$t("物品辨识")}
            ],
            selectedIds: [], //多选中的素材id列表
            selectedId: null, //单选选中的素材id
            scrollUpdating: false,
            showLoadingMask: false,
            isManage: false,
            listScrollContainer: null
        };
    },
    computed: {
        ...mapState('user', [
            'teamId',
            'token'
        ]),
        filterMaterials() {
            let list = this.materialsList ? this.materialsList.payload : [];
            if(this.isManage){
                return list;
            }
            list = list.filter(item => {
                if (item.type === this.searchMaterialType || this.isMaterialType(item.url, this.searchMaterialType)) {
                    return true;
                } else {
                    return false;
                }
            });
            return list;
        },
        noMoreData(){
            if(!this.materialsList){
                return false;
            }
            return this.materialsList.query.currentPage >= this.materialsList.query.totalPages;
        },
        showNoMoreData(){
            if(!this.materialsList){
                return false;
            }
            let query = this.materialsList.query;
            if(query.totalPages <= 1){
                return false;
            }
            return this.materialsList.query.currentPage >= this.materialsList.query.totalPages;
        },
         ...mapState({
            //素材区已有的数据
            materialAreaList: state => state.materialsList || []
        }),
        canConfirm() {
            if(this.method === "manage" || this.isManage){
                return !!this.selectedId;
            } else {
                return this.method === "add" ? this.selectedIds.length > 0 : !!this.selectedId;
            }
        },
        lockScrollUpdate(){
            if(!this.materialsList){
                return false;
            }
            return this.noMoreData || this.scrollUpdating;
        },
        typedCategories(){
            const categories = this.materialCategories;
            const searchMaterialType = this.searchMaterialType;
            let arr = [{
                materialCategoryId: null,
                i18n: {},
                short: this.$t("all")
            }];
            categories.forEach(item => {
                if(item.type === searchMaterialType){
                    arr.push(item);
                }
            })
            return arr;
        }
    },
    watch: {
        "filterMaterials.length"() {
            this.$nextTick(() => {
                if (this.$refs.matrialsScrollbar) {
                    this.$refs.matrialsScrollbar && this.$refs.matrialsScrollbar.update();
                }
            });
        },
        searchMaterialType(){
            if(!this.inited){
                return;
            }
            this.$nextTick(() => {
                this.onsearchMaterialTypeChange();
            });
        },
        isManage(){
            this.selectedIds = [];
            this.selectedId = null;
            this.initData();
        },
        showLoadingMask(value){
            value && (this.scrollUpdating = false);
        }
    },
    mounted() {
        this.materialOwner = this.owner === "nuwa" ? this.owner : this.teamId;
        if(this.materialOwner !== "nuwa"){
            this.showSearchInput = true;
        }
        if(this.method === "manage"){
            this.isManage = true;
        }
        this.searchMaterialType = this.materialTypes.find(item => item.key === this.type) ? this.type : this.materialTypes[0].key;
        this.getMaterialCategories(() => {
            if(["image", "video"].includes(this.searchMaterialType) && this.materialCategories.length > 0){
                this.selectedCategory = this.materialCategories[0].materialCategoryId;
            } else {
                this.selectedCategory = null;
            }
            this.$nextTick(() => {
                this.initData();
                this.inited = true;
            })
        });
        this.$nextTick(() => {
            this.listScrollContainer = this.$refs.matrialsScrollbar.$el.querySelector('.el-scrollbar__wrap')
        })
    },
    methods: {
        initData(updateTag = true) {
            this.showLoadingMask = true;
            if(this.isManage){
                this.getMaterialData("all", 1, res => {
                    if (res) {
                        this.materialsList = res;
                    }
                    this.showLoadingMask = false;
                });
            } else {
                if(this.materialOwner === "nuwa" && updateTag){
                    this.updateMaterialTags(this.searchMaterialType, () => {
                        this.getMaterialData(this.searchMaterialType, 1, res => {
                            if (res) {
                                this.materialsList = res;
                            }
                            this.showLoadingMask = false;
                        });
                    });
                } else {
                    this.getMaterialData(this.searchMaterialType, 1, res => {
                        if (res) {
                            this.materialsList = res;
                        }
                        this.showLoadingMask = false;
                    });
                }
            }
        },
        updateMaterialTags(type, next = () => {}) {
            const langCode = Cookies.get("langCode");
            let searchType = ["image", "video"].includes(type)? "media": type;
            this.http$(
                "get",
                "/developTool/material/tags",
                {
                    type: searchType,
                    limit: 0,
                    page: 1,
                    customerId: this.teamId
                },
                null,
                {
                    Authorization: "Bearer " + this.token
                }
            ).then(res => {
                if(this.searchMaterialType === type){
                    res = res.data;
                    if (res.status && res.status.code === "0" && res.data) {
                        res = res.data;
                        this.materialTags = res.payload.map(item => {
                            let label = item.i18n.find(item2 => item2.langCode === langCode);
                            label = label ? label.name : "";
                            return {
                                materialTagId: item.materialTagId,
                                label
                            };
                        }).filter(item => item.label);
                    } else {
                        this.materialTags = [];
                    }
                    next();
                }
            }).catch(() => {
                if(this.searchMaterialType === type){
                    this.materialTags = [];
                    next();
                }
            });
        },
        getMaterialCategories(next = () => {}){
            console.log("get material categories");
            let searchType = ["image", "video"].includes(this.searchMaterialType)? "media": this.searchMaterialType;
            this.http$(
                "get",
                "/developTool/material/categories",
                {
                    type: searchType,
                    customerId: this.teamId,
                    page: 1,
                    limit: 0
                },
                null,
                {
                    Authorization: "Bearer " + this.token
                }
            ).then(res => {
                if(res.data && res.data.data && res.data.data.payload){
                    if(searchType === "media"){
                        this.materialCategories = res.data.data.payload.filter(item => {
                            let i18nEn = item.i18n.find(lang => lang.langCode === "en-US");
                            let desc = i18nEn.description;
                            if(this.type === "video"){
                                return /(video|movie|film)/ig.test(desc);
                            } else {
                                return !/(video|movie|film)/ig.test(desc);
                            }
                        })
                    } else {
                        this.materialCategories = res.data.data.payload;
                    }
                } else {
                    this.materialCategories = [];
                }
                next();
            }).catch(err => {
                console.error("get material category error:", err);
                this.materialCategories = [];
                next();
            })
        },
        toggleTagsList() {
            this.showTagList = !this.showTagList;
            this.$nextTick(() => {
                if (this.$refs.matrialsScrollbar) {
                    this.$refs.matrialsScrollbar.update();
                }
                if(this.showTagList && this.$refs.tagScroll){
                    let tagScroll = this.$refs.tagScroll;
                    tagScroll.$el.parentNode.style.height = (tagScroll.$el.querySelector(".el-scrollbar__view").offsetHeight + 16) + "px";
                    this.$nextTick(() => {
                        this.$refs.tagScroll.update();
                    });
                }
            });
        },
        onSelectTag(materialTag) {
            if (this.selectedTags.find(item => item.materialTagId === materialTag.materialTagId)) {
                this.onDeleteTag(materialTag.materialTagId);
            } else {
                this.selectedTags.push(materialTag);
                this.$nextTick(() => {
                    this.showLoadingMask = true;
                    this.getMaterialData(this.searchMaterialType, 1, res => {
                        if (res) {
                            this.materialsList = res;
                        }
                        this.showLoadingMask = false;
                    });
                })
            }
        },
        onDeleteTag(materialTagId) {
            this.selectedTags = this.selectedTags.filter(item => item.materialTagId !== materialTagId);
            this.$nextTick(() => {
                this.showLoadingMask = true;
                this.getMaterialData(this.searchMaterialType, 1, res => {
                    if (res) {
                        this.materialsList = res;
                    }
                    this.showLoadingMask = false;
                });
            })
        },
        onShowSearchinput() {
            this.searchKeyWord = "";
            this.showSearchInput = true;
            this.showTagList = false;
            this.$nextTick(() => {
                this.$refs.searchInput.$el.querySelector(".el-input__inner").focus();
                this.materialsList = null;
                this.showLoadingMask = true;
                this.getMaterialData(this.searchMaterialType, 1, res => {
                    if(res){
                        this.materialsList = res;
                    }
                    this.showLoadingMask = false;
                });
            });
        },
        onSearchKeywordChange(){
            console.log("searchKeyword change");
            this.showLoadingMask = true;
            this.getMaterialData(this.searchMaterialType, 1, res => {
                if (res) {
                    this.materialsList = res;
                }
                this.showLoadingMask = false;
            });
        },
        closeSearchinput() {
            if(this.materialOwner !== "nuwa"){
                if(this.searchKeyWord){
                    this.searchKeyWord = "";
                    this.onSearchKeywordChange();
                }
                return;
            }
            this.showSearchInput = false;
            this.$nextTick(() => {
                this.showLoadingMask = true;
                this.getMaterialData(this.searchMaterialType, 1, res => {
                    if(res){
                        this.materialsList = res;
                    }
                    this.showLoadingMask = false;
                });
            });
        },
        getMaterialData(type, page = 1, next = () => { }) {
            console.log("get material data");
            let searchType = ["image", "video"].includes(type)? "media": type;
            let tagIds = "";
            let isManage = this.isManage;
            let category = this.selectedCategory;
            let owner = this.materialOwner;

            let query = {
                type: searchType,
                limit: 20,
                page,
                owner,
                customerId: this.teamId
            };
            if (!this.showSearchInput) {
                tagIds = this.selectedTags.map(item => item.materialTagId).join(",");
                !isManage && tagIds && (query.tags = tagIds);
                category && (query.category = category);
            } else if(this.searchKeyWord && !isManage){
                query = Object.assign(query, {
                    page: 1,
                    limit: 0,
                    keyword: this.searchKeyWord
                });
            }
            this.http$("get", "/developTool/materials", query, null, {
                Authorization: "Bearer " + this.token
            }).then(res => {
                if(type === this.searchMaterialType && owner === this.materialOwner && isManage === this.isManage){
                    if (res.data && res.data.status.code === "0") {
                        let data = res.data.data;
                        data.query.type = searchType;
                        if (searchType === "media") {
                            data.payload = data.payload.filter(item => this.isMaterialType(item.url, type));
                            next(data);
                        } else {
                            next(data);
                        }
                    } else {
                        next(null);
                    }
                }
            }).catch(() => {
                if(type === this.searchMaterialType && owner === this.materialOwner && isManage === this.isManage){
                    next(null);
                }
            });
        },
        //切換素材所有者
        switchMaterialOwner(){
            this.materialTags = [];
            this.selectedCategory = null;
            if(this.materialOwner !== "nuwa"){
                this.showSearchInput = true;
                this.showTagList = false;
            } else {
                this.showSearchInput = false;
                this.searchKeyWord = "";
            }
            this.$nextTick(() => {
                this.onsearchMaterialTypeChange();
            });
        },
        //素材目录切换
        onSelectCategory(categoryId, materialType){
            this.selectedCategory = categoryId;
            if(this.searchMaterialType === materialType){
                this.onsearchMaterialTypeChange(false);
            } else {
                this.searchMaterialType = materialType;
            }
        },
        //切换素材类型
        onsearchMaterialTypeChange(updateTag = true) {
            this.selectedIds = [];
            this.selectedId = null;
            this.searchKeyWord = "";
            this.selectedTags = [];
            if(updateTag){
                this.materialTags = [];
            }
            if (this.$refs.matrialsScrollbar.$el.querySelector(".el-scrollbar__wrap")) {
                this.$refs.matrialsScrollbar.$el.querySelector(".el-scrollbar__wrap").scrollTop = 0;
            }
            this.initData(updateTag);
        },
        singleClickType(materialType){
            this.selectedCategory = null;
            if(materialType === this.searchMaterialType){
                 this.selectedIds = [];
                this.selectedId = null;
                this.searchKeyWord = "";
                this.selectedTags = [];
                if (this.$refs.matrialsScrollbar.$el.querySelector(".el-scrollbar__wrap")) {
                    this.$refs.matrialsScrollbar.$el.querySelector(".el-scrollbar__wrap").scrollTop = 0;
                }
                this.showLoadingMask = true;
                this.getMaterialData(materialType, 1, res => {
                    if (res) {
                        this.materialsList = res;
                    }
                    this.showLoadingMask = false;
                })
            } else {
                return;
            }
        },
        //素材选中
        onMaterilSelect(data) {
            let materialId = data.materialId;
            let isInMaterialArea = this.isInMaterialArea(materialId);
            if (isInMaterialArea) {
                return;
            }
            if(this.isManage || this.method === "replace"){
                this.selectedId = materialId;
            } else if (this.method === "add") {
                let index = this.selectedIds.findIndex(
                    item => item === materialId
                );
                if (index >= 0) {
                    this.selectedIds.splice(index, 1);
                } else {
                    this.selectedIds.push(materialId);
                }
            }
        },
        //添加素材到素材库
        confirmMaterials() {
            let materials;
            if (!this.canConfirm) {
                return;
            }
            if (this.method === "add") {
                let selectedIds = this.selectedIds;
                materials = this.filterMaterials.filter(item =>
                    selectedIds.includes(item.materialId)
                );
            } else {
                let materialId = this.selectedId;
                materials = this.filterMaterials.filter(
                    item => item.materialId === materialId
                );
            }
            this.$emit("confirm", {
                type: this.searchMaterialType,
                method: this.method,
                data: materials
            });
            this.$nextTick(() => {
                this.onMaterialDialogClose();
            });
        },
        beforeDeleteMaterials(){
            if (!this.canConfirm) {
                return;
            }
            let deleteMaterial = this.materialsList.payload.find(item => item.materialId === this.selectedId);
            let materialName = deleteMaterial ? deleteMaterial.metadata.title : ""
            this.$confirm(
                this.$t("message.warn_delete_team_materials", {name: materialName}),
                this.$t("popper_title.delete_material"),
                {
                    confirmButtonText: this.$t("top.delete"),
                    cancelButtonText: this.$t("button.cancel"),
                    type: "info",
                    customClass: "editor-important-tip",
                    cancelButtonClass: "editor-pop-btn gray",
                    confirmButtonClass: "editor-pop-btn blue"
                }
            ).then(() => {
                this.onDeleteMaterials([this.selectedId]);
            }).catch(() => {});
        },
        onDeleteMaterials(materialIds){
            this.$api.delDevelopToolMaterial({
                headers: {
                    "Content-type": "application/json"
                },
                body: {
                    customerId: this.teamId,
                    ids: materialIds
                }
            }).then(() => {
                this.materialsList.payload = this.materialsList.payload.filter(item => !materialIds.includes(item.materialId));
                this.selectedId = null;
                this.$message.success("message.success_delete_material");
            }).catch((err) => {
                console.log(err);
                this.$message.error("message.error_delete_material");
            });
        },
        //关闭素材库弹窗
        onMaterialDialogClose() {
            this.$emit("cancel");
        },
        //素材库的素材是否已被添加到素材区中
        isInMaterialArea(materialId) {
            if(this.method === "manage" || this.isManage){
                return false;
            }
            return this.materialAreaList.find(item => item.ref === materialId) ? true : false;
        },
        isMaterialType(url, type) {
            let map = {
                image: ["jpg", "jpeg", "png", "gif"],
                video: ["mp4", "mpeg", "webm", "mov"],
                audio: ["mp3", "wav", "ogg"]
            };
            if (!map[type]) {
                return false;
            }
            url = url || "";
            url = url.split("?").shift();
            let format = url.split(".").pop();
            return map[type].includes(format);
        },
        onMaterialListScroll() {
            if(!this.lockScrollUpdate){
                this.scrollUpdating = true;
                let materialList = this.materialsList;
                this.getMaterialData(this.searchMaterialType, materialList.query.currentPage + 1, res => {
                    if (res) {
                        this.materialsList = {
                            payload: [...this.materialsList.payload, ...res.payload],
                            query: res.query
                        };
                    }
                    this.scrollUpdating = false;
                });
            }
            
        }
    },
    components: {
        listEmpty,
        materialItem
    }
};
</script>
<style lang="scss">
.codelab-popper.material-online-dialog {
    border-radius: 0;
    .top-button{
        height: 32px;
        line-height: 20px;
        padding: 6px 14px;
        background: transparent;
        outline: none;
        border: none;
        color: #c8c8c8;
        font-size: 14px;
        position: absolute;
        top: 10px;
        right: 48px;
        &:hover{
            color: #0ed3ff;
            .svg-icon{
                fill: #0ed3ff;
                stroke: #0ed3ff;
            }
        }
        .svg-icon{
            stroke: #c8c8c8;
            fill: #c8c8c8;
        }
        .button-label{
            vertical-align: middle;
        }
    }
    .materials-online {
        width: 100%;
        height: 60vh;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        .material-owner-tabs{
            .el-tabs__nav-wrap{
                &::after{
                    height: 5px;
                    background-color: transparent;
                }
                .el-tabs__item{
                    font-size: 16px;
                    font-weight: normal;
                    color: #c8c8c8;
                    &.is-active{
                        color: #ffffff;
                    }
                }
                .el-tabs__active-bar{
                    height: 5px;
                    background-color: #d8d8d8;
                }
            }
        }
        .materials-search {
            min-height: 50px;
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;
            flex: 0 0 auto;
            background: #333333;
            .material-type-select {
                border: none;
                border-radius: 0;
                flex: 0 0 auto;
                .el-input__inner {
                    color: #ffffff;
                    padding-left: 14px;
                    background: none;
                    border: none;
                    height: 50px;
                }
            }
            .search-right {
                width: 100%;
                height: 100%;
                min-height: 50px;
                border-left: 1px solid #696969;
                flex: 0 1 auto;
                padding: 4px 10px;
                &.is-customer{
                    border-left: none;
                }
                .key-words-input {
                    height: 32px;
                    margin-top: 5px;
                    .el-input__inner {
                        background: #444444;
                        border-color: transparent;
                        border-width: 1px;
                        &:focus {
                            color: #45e5f4;
                            border-color: #45e5f4;
                        }
                    }
                }
                .selected-tags-slot {
                    width: 100%;
                    height: 100%;
                    display: flex;
                    align-items: flex-start;
                    .search-icon {
                        display: block;
                        width: 32px;
                        height: 32px;
                        margin-top: 5px;
                        line-height: 32px;
                        border-radius: 2px;
                        background: #444444;
                        flex: 0 0 auto;
                        text-align: center;
                        color: #a8a8ac;
                        cursor: pointer;
                        &:hover {
                            color: #ffffff;
                        }
                    }
                    .toggle-tag-list {
                        display: block;
                        width: 32px;
                        height: 32px;
                        line-height: 32px;
                        flex: 0 0 auto;
                        transform-origin: center center;
                        text-align: center;
                        color: #a8a8ac;
                        &.active {
                            transform: rotateZ(180deg);
                        }
                    }
                    .tags-container {
                        width: 100%;
                        height: 100%;
                        padding: 0 5px;
                        flex: 0 1 auto;
                        white-space: nowrap;
                        .tag-item {
                            display: block;
                            height: 32px;
                            line-height: 30px;
                            text-align: center;
                            padding: 0 24px 0 12px;
                            margin: 5px;
                            float: left;
                            color: #ffffff;
                            background: #444444;
                            border-radius: 2px;
                            position: relative;
                            border: 1px solid transparent;
                            &:hover {
                                border-color: #45e5f4;
                            }
                            .delete-tag {
                                display: block;
                                width: 24px;
                                height: 24px;
                                line-height: 24px;
                                text-align: center;
                                position: absolute;
                                top: 4px;
                                right: 0;
                                color: #a8a8ac;
                                &:hover {
                                    color: #ffffff;
                                }
                            }
                        }
                    }
                }
            }
        }
        .material-tags-list {
            width: 100%;
            max-height: 137px;
            min-height: 57px;
            padding: 5px;
            flex: 0 0 auto;
            background: #333333;
            font-size: 14px;
            color: #ffffff;
            border-top: 1px solid #696969;
            .tags-container {
                width: 100%;
                overflow: hidden;
                .tag-item {
                    display: block;
                    height: 32px;
                    line-height: 30px;
                    text-align: center;
                    padding: 0 12px;
                    margin: 5px;
                    float: left;
                    background: #444444;
                    border-radius: 2px;
                    border: 1px solid transparent;
                    &.selected {
                        background: rgba(14, 211, 255, 0.3);
                    }
                    &:hover {
                        border-color: #45e5f4;
                    }
                }
            }
        }
        .manage-tip{
            width: 100%;
            height: 50px;
            padding: 0 14px;
            line-height: 50px;
            margin-top: 0px;
            color: #00b5e2;
            background: #333333;
        }
        .materials-container {
            width: 100%;
            height: 100%;
            overflow: hidden;
            flex: 0 1 auto;
            position: relative;
            .materials-online-scrollbar {
                .el-radio-group,
                .el-checkbox-group {
                    width: 100%;
                    height: 100%;
                    overflow: hidden;
                }
                ul {
                    width: calc(100% + 20px);
                    margin: 0 -10px;
                    padding: 0 5px;
                    overflow: hidden;
                    li {
                        width: 174px;
                        height: 132px;
                        overflow: hidden;
                        border: 1px solid transparent;
                        margin: 8px;
                        float: left;
                        background: #363636;
                        position: relative;
                        &:hover {
                            box-shadow: 0px 0px 4px #3399ff;
                        }
                        &.active,
                        &:active {
                            border-color: #3399ff;
                        }
                        .select-material-box,
                        .select-material-radio {
                            position: absolute;
                            right: 6px;
                            top: 6px;
                            pointer-events: none;
                            .is-disabled {
                                .el-radio__inner {
                                    background: #696969;
                                }
                            }
                            .el-checkbox__label,
                            .el-radio__label {
                                display: none;
                            }
                        }
                        .el-checkbox {
                            &.is-disabled {
                                .el-checkbox__inner {
                                    background: #a8a8ac;
                                }
                            }
                        }
                    }
                }
                .data-finale-mask{
                    background: #333;
                    font-size: 15px;
                    line-height: 48px;
                    text-align: center;
                    color: #a8a8ac;
                }
            }
            .scroll-bottom-tip{
                width: 100%;
                position: absolute;
                bottom: 0;
                left: 0;
                color: #ffffff;
                background: rgba(0,0,0,0.9);
                font-size: 15px;
                line-height: 48px;
                text-align: center;
            }
            .loading-mask{
                position: absolute;
                width: 100%;
                height: 100%;
                overflow: hidden;
                z-index: 2;
                top: 0;
                left: 0;
                background-color: #444444;
                .loading-icon{
                    position: absolute;
                    width: 46px;
                    height: 46px;
                    left: 50%;
                    top: 50%;
                    margin-left: -23px;
                    margin-top: -23px;
                    animation: ani-circle linear 2.5s infinite;
                }
                ul{
                    width: calc(100% + 10px);
                    margin: 0 -5px;
                    .bg-item{
                        width: 20%;
                        height: 130px;
                        padding: 5px;
                        float: left;
                        &::after{
                            content: "";
                            display: block;
                            width: 100%;
                            height: 100%;
                            background: #333333;
                        }
                    }
                }
            }
        }
    }
    .el-dialog__header{
        background: transparent;
        text-align: center;
    }
    .el-dialog__footer {
        .footer-button-group {
            display: block;
            text-align: right;
            .popper-footer-button {
                margin-left: 18px;
            }
        }
    }
    .el-scrollbar{
        border-radius: 0;
    }
}
@keyframes ani-circle{
    from {transform: rotate(0deg);}
    to {transform: rotateZ(-360deg);}
}
.el-select-dropdown.material-type-select-options {
    border: none;
    border-radius: 0;
    margin-top: 4px;
    background: #333333;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
    .el-scrollbar{
        border-radius: 0;
    }
    &::before {
        display: none;
    }
    .popper__arrow{
        display: none;
    }
    .el-select-dropdown__item{
        padding: 0;
        color: #ffffff;
        &:hover,&.hover{
            background: #444444;
            color: #0ed3ff;
        }
        &.selected{
            color: #0ed3ff;
            font-weight: normal;
        }
        >span,>.customer-item{
            display: block;
            width: 100%;
            padding: 0 20px;
        }
        >.customer-item{
            padding-right: 0;
            .label{
                display: inline-block;
                width: calc(100% - 24px);
            }
            .expand-icon{
                display: inline-block;
                width: 24px;
            }
        }
    }
}
</style>
